import React from 'react';
import { Grid, Typography, Button } from '@mui/material';
import logoicn from "./../../../src/assets/images/404.png";
import { useNavigate } from 'react-router-dom';

function NotFound() {
    const navigate = useNavigate(); // Initialize the navigate function

    const handleButtonClick = () => {
        navigate('/dashboard'); // Navigate to the /home page
    };
    return (
        <Grid
            container
            spacing={0}
            sx={{
                direction: 'ltr',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}
        >
            <Grid
                item
                xs={12}
                lg={12}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}
            >
                <img
                    style={{ width: 500, height: 500, marginTop: -100 }}
                    alt="Logo"
                    src={logoicn}
                />
                <Typography sx={{ textAlign: 'center', marginTop: -10 }} variant="h2">
                    صفحه مورد نظر یافت نشد!!!!!!!!!!!!!!!
                </Typography>

                <Button
                    onClick={handleButtonClick}
                    sx={{ marginTop: 2 }} color="redColor" variant="outlined" size="large">
                    <Typography sx={{ paddingRight: 5, paddingLeft: 5 }} variant='button' color="#d90429">برگشت به صفحه اصلی</Typography>
                </Button>
            </Grid>
        </Grid>
    );
}

export default NotFound;
